.RAContainer
    width: 100%
    display: flex
    flex-direction: column
    flex-grow: 1
.RADefault
    background-color: rgb($globalSettingsBackgroundPrimary)
    border-top: 1px solid rgb($globalSettingsStrokePrimary)
.RAConfig
    gap: 10px
.RACheckout
    background-color: rgb($globalSettingsBackgroundPrimary)
